export * from './company-profiles.generated'
export * from './patch-tp-company-profile.mutation.generated'
export * from './tp-company-profile.fragment.generated'
